<template>
  <section class="mt-2">
    <apexchart v-if="series"
      type="area"
      height="230"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </section>
</template>
        
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import dashboardStoreModule from "../dashboardStoreModule";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "area",
          zoom: {
            enabled: false,
          },

          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },

        title: {
          text: "總數量",
          align: "left",
        },
        // subtitle: {
        //   text: 'Price Movements',
        //   align: 'left'
        // },
        labels: Array.from({ length: 6 }, (_, i) => (new Date().getFullYear() - (5 - i)).toString()),
        xaxis: {
          type: "year",
        },
        yaxis: {
          //   opposite: true
        },
        legend: {
          horizontalAlign: "left",
        },
      },
    };
  },
  props: {
    series: {
        type: Array,
        required: true,
    },
  },
  computed: {},
  methods: {},
  setup() {},
};
</script>
        
  <style lang="scss" scoped>
.apexcharts-toolbar {
  display: none;
}
</style>
        
    <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
        